import styles from './index.module.scss';

const nodes = [
  { id: 'UE', x: 125, y: 393, w: 56, h: 58, sub: 'SIMULATED UE' },
  { id: 'gNB', x: 270, y: 452, w: 64, h: 65, sub: 'SIMULATED RAN' },
  { id: 'AMF', x: 359, y: 283, w: 71, h: 68, sub: 'CONTROL PLANE' },
  { id: 'SMF', x: 507, y: 348, w: 71, h: 68, sub: 'CONTROL PLANE' },
  { id: 'UPF', x: 633, y: 417, w: 71, h: 68, sub: 'USER PLANE' },
  { id: 'AUSF', x: 353, y: 163, w: 52, h: 40, sub: 'AUTHENTICATE' },
  { id: 'UDM', x: 478, y: 207, w: 52, h: 40, sub: 'SUBSCRIBERS' },
  { id: 'NRF', x: 588, y: 155, w: 52, h: 40, sub: 'DISCOVERY' },
  { id: 'PCF', x: 681, y: 264, w: 52, h: 40, sub: 'POLICY' },
];

const wires = [
  ['M125 410 195 444 270 478', '', 0, 0, ''],
  ['M270 452 229 430 229 348 359 283', 'N2 / NGAP', 205, 316, ''],
  ['M359 302 434 342 507 367', 'SBI', 458, 350, ''],
  ['M507 367 565 397 633 436', 'N4 / PFCP', 596, 380, ''],
  ['M270 478 438 561 633 455', 'N3 / GTP-U', 458, 522, 'user'],
  ['M633 455 721 500 779 471', 'N6', 746, 512, 'user'],
  ['M359 283 294 248 294 207 353 181', '', 0, 0, ''],
  ['M353 181 418 214 478 225', 'SBI', 421, 190, ''],
  ['M478 225 533 252 588 173', '', 0, 0, ''],
  ['M507 348 553 325 553 285 681 282', 'SBI', 596, 274, ''],
  ['M588 173 700 230 681 282', '', 0, 0, ''],
] as const;

const FiveGsAuthBackdrop = () => (
  <div className={styles.backdrop} aria-hidden="true">
    <div className={styles.halo} />

    <div className={styles.stage}>
      <div className={styles.stageLabel}>
        <span className={styles.liveDot} />
        NETWORK TOPOLOGY
      </div>

      <svg
        className={styles.topology}
        viewBox="0 0 800 650"
        focusable="false"
      >
        <defs>
          <linearGradient id="authTopFace" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#23383c" />
            <stop offset="1" stopColor="#0a151a" />
          </linearGradient>

          <linearGradient id="authLeftFace" x2="0" y2="1">
            <stop stopColor="#15272c" />
            <stop offset="1" stopColor="#080f13" />
          </linearGradient>

          <linearGradient id="authRightFace" x2="1" y2="1">
            <stop stopColor="#122227" />
            <stop offset="1" stopColor="#071013" />
          </linearGradient>

          <linearGradient id="authCoreFace" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#215454" />
            <stop offset="1" stopColor="#103333" />
          </linearGradient>

          <radialGradient id="authFloorGlow">
            <stop stopColor="#55edbc" stopOpacity=".14" />
            <stop offset="1" stopColor="#55edbc" stopOpacity="0" />
          </radialGradient>

          <filter id="authGlow">
            <feGaussianBlur stdDeviation="4" />
          </filter>

          <pattern
            id="authFloorGrid"
            width="42"
            height="42"
            patternUnits="userSpaceOnUse"
            patternTransform="matrix(1 .45 -1 .45 400 40)"
          >
            <path
              d="M42 0H0V42"
              fill="none"
              stroke="#56746b"
              strokeOpacity=".17"
              strokeWidth="1"
            />
          </pattern>
        </defs>

        <ellipse
          cx="420"
          cy="375"
          rx="380"
          ry="220"
          fill="url(#authFloorGlow)"
        />

        <path
          d="M400 70 795 300 795 455 420 650 0 425 0 270Z"
          fill="url(#authFloorGrid)"
        />

        <g fill="none" stroke="#4d8878">
          <ellipse
            cx="427"
            cy="361"
            rx="302"
            ry="153"
            strokeOpacity=".10"
          />
          <ellipse
            cx="427"
            cy="361"
            rx="268"
            ry="136"
            strokeOpacity=".17"
            strokeDasharray="3 12"
          />
        </g>

        <g>
          {wires.map(([d, label, x, y, type], index) => (
            <g key={`${d}-${index}`}>
              <path
                className={`${styles.networkWire} ${
                  type === 'user' ? styles.userWire : ''
                }`}
                d={d}
              />
              <path
                className={`${styles.wirePulse} ${
                  type === 'user' ? styles.userPulse : ''
                }`}
                d={d}
                style={{ animationDelay: `-${index * 0.57}s` }}
              />
              {label && (
                <text className={styles.wireLabel} x={x} y={y}>
                  {label}
                </text>
              )}
            </g>
          ))}
        </g>

        <g>
          {nodes.map((node, index) => {
            const { id, x, y, w, h, sub } = node;
            const depth = w * 0.48;

            return (
              <g
                key={id}
                className={`${styles.node} ${
                  id === 'UE' ? styles.selectedNode : ''
                }`}
              >
                <ellipse
                  className={styles.nodeHalo}
                  cx={x}
                  cy={y + depth + h + 4}
                  rx={w}
                  ry="12"
                />

                <path
                  className={styles.face}
                  fill="url(#authLeftFace)"
                  d={`M${x - w} ${y}l${w} ${depth}v${h}l-${w} -${depth}Z`}
                />

                <path
                  className={styles.face}
                  fill="url(#authRightFace)"
                  d={`M${x} ${y + depth}l${w} -${depth}v${h}l-${w} ${depth}Z`}
                />

                <path
                  className={`${styles.face} ${styles.topFace}`}
                  fill={
                    id === 'UE'
                      ? 'url(#authCoreFace)'
                      : 'url(#authTopFace)'
                  }
                  d={`M${x} ${y - depth}l${w} ${depth} -${w} ${depth} -${w} -${depth}Z`}
                />

                <path
                  d={`M${x - w + 9} ${y + 9}l${w - 9} ${depth - 4} ${
                    w - 9
                  } -${depth - 4}`}
                  fill="none"
                  stroke={index === 4 ? '#74e7d9' : '#9cce8d'}
                  opacity=".5"
                />

                <text
                  className={styles.nodeTitle}
                  x={x}
                  y={y + 5}
                  style={{ fontSize: w < 60 ? 16 : 21 }}
                >
                  {id}
                </text>

                <text
                  className={styles.nodeSub}
                  x={x}
                  y={y + depth + h + (id === 'AUSF' ? 10 : 24)}
                >
                  {sub}
                </text>

                <circle
                  className={styles.nodeStatus}
                  cx={x + 10}
                  cy={y + depth + 14}
                  r="2"
                />

                <path
                  d={`M${x + 19} ${y + depth + 10}v6m5-9v6m5-9v6`}
                  stroke="#48644f"
                  strokeWidth="2"
                />
              </g>
            );
          })}
        </g>

        <g className={styles.topologyCaption}>
          <text x="495" y="84">
            SERVICE-BASED ARCHITECTURE
          </text>
          <path
            d="M480 80H450L419 99"
            fill="none"
            stroke="#60706a"
          />
          <text x="69" y="540">
            ACCESS NETWORK
          </text>
          <path
            d="M185 536H211L235 507"
            fill="none"
            stroke="#60706a"
          />
        </g>
      </svg>
    </div>
  </div>
);

export default FiveGsAuthBackdrop;
